export function inBrowser(): boolean {
  return typeof window === 'object' && typeof document === 'object'
}
